import loadDatadog from './dataDog/index';
import loadSurveyScript from './survey/medallia';

const loadExternalDependencies = async () => {
  loadSurveyScript();
  loadDatadog();
};

export default loadExternalDependencies;
